<!--
 * @Author: fengqianhui
 * @Date: 2024-01-10 12:07:17
 * @LastEditors: 18518155760 111m
 * @LastEditTime: 2024-01-18 16:56:25
 * @FilePath: \landingpage\src\views\build\components\BadgeArea.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<script setup lang="ts">
import { useOriginDataStore } from '@/stores/originDataStore';
import { debounce } from 'lodash';
const store = useOriginDataStore();
const autoTestData = computed(() => store.data?.autoTest);
const autoTestLevel = computed(() => store.data?.autoTestLevel);
//测试通过
const testType1 = computed(() => {
  return autoTestData?.value?.filter((item) => item.result == 2) || [];
});
//测试不通过
const testType2 = computed(() => {
  return autoTestData?.value?.filter((item) => item.result == 3) || [];
});
const goUrl = (url: string) => {
  window.open(url, '_blank');
};
const debouncedGoUrl = debounce(goUrl, 200);
</script>

<template>
  <div class="right">
    <div class="list" v-for="(item, index) in testType1" :key="index">
      <div class="single-icon" @click="debouncedGoUrl(item?.reportUrl)">
        <div class="text">{{ item.passCount }}/{{ item.totalCount }}</div>
        <img src="@/assets/pass.png" alt="" />
      </div>
    </div>
    <div class="list" v-for="(item, index) in testType2" :key="index">
      <div class="single-icon" @click="debouncedGoUrl(item?.reportUrl)">
        <div class="text" style="color: rgb(91, 91, 91)">{{ item.passCount }}/{{ item.totalCount }}</div>
        <img src="@/assets/fail.png" alt="" />
      </div>
    </div>
    <a-tooltip placement="top" class="tooltip">
      <template #title>
        <div>青铜：经正常安装且启动正常</div>
        <div>黄金：经通用脚本6小时压力测试正常</div>
        <div>王者：经专用脚本6小时压力测试正常</div>
      </template>
      <div class="single-icon" style="margin-left: 12px" v-show="autoTestLevel == 1">
        <img src="@/assets/level1.png" alt="" />
      </div>
      <div class="single-icon" style="margin-left: 12px" v-show="autoTestLevel == 2">
        <img src="@/assets/level2.png" alt="" />
      </div>
      <div class="single-icon" style="margin-left: 12px" v-show="autoTestLevel == 3">
        <img src="@/assets/level3.png" alt="" />
      </div>
    </a-tooltip>
  </div>
</template>

<style scoped lang="less">
.right {
  width: 100%;
  padding: 0 auto;
  overflow-y: auto;
  .single-icon {
    margin-left: 20px;
    margin-top: 20px;
    position: relative;
    cursor: pointer;
    .text {
      position: absolute;
      left: 31px;
      top: 30px;
      font-size: 20px;
      color: rgb(18, 185, 45);
      font-family: PingFangSC-Heavy;
      font-size: 24px;
      width: 66px;
      text-align: center;
    }
  }
  .tooltip {
    font-size: 14px;
  }
}
</style>
